import { useSelector } from 'react-redux';

import { selectCurrentUser } from '../../store/modules/users/selectors';
import AnalyticsAPI from './AnalyticsAPI';

const Analytics = () => {
  const enable = process.env.REACT_APP_SEGMENT_ENABLE || '0';
  const token = process.env.REACT_APP_SEGMENT_ID || '';
  const { data: user } = useSelector(selectCurrentUser);

  if (enable === '0'){
    return null;
  }

  if (!window.analytics){
    AnalyticsAPI(token);
  }

  if (user && window.analytics.initialized){
    // Here we only need to send the user id's because the backend will handle the full
    // description of the user when they login
    // This Identify just helps with session tracking so that other events are associated to the correct User
    window.analytics.identify(user.id.toString(), {
      userName: user.username,
      email: user.email,
    } );
  }

  return null;
};

export default Analytics;
